export interface AiAgentParameter {
    name: string;
    description?: string;
}